import { toast } from "react-hot-toast";
import { FiTrash2, FiDownload, FiUsers } from "react-icons/fi";
import { FileItem } from "../Components";
import { downloadFile } from "./downloadUtils";
import { FOLDER_TYPES, MESSAGES } from "../constants";

const FolderView = ({
  currentFolder,
  openFolder,
  handleDeleteItem,
  folderType,
  openAccessModal,
}) => {
  const onDownloadFile = async (file) => {
    try {
      await downloadFile(file);
      toast.success(MESSAGES.FILE_DOWNLOAD_SUCCESS);
    } catch {
      toast.error(MESSAGES.FILE_DOWNLOAD_FAILED);
    }
  };

  if (!currentFolder) {
    return (
      <div className="text-center text-gray-500 mt-20">
        No folders available.
      </div>
    );
  }

  const folders = currentFolder.subfolders || [];
  const files = currentFolder.files || [];

  return (
    <div className="space-y-2">
      {/* FOLDERS */}
      {folders.map((folder) => (
        <div
          key={folder.id}
          className="flex items-center justify-between px-4 py-2 hover:bg-blue-50 rounded group"
        >
          <div
            className="flex items-center gap-3 cursor-pointer text-secondary font-medium"
            onClick={() => openFolder(folder)}
          >
            📁 {folder.name}
          </div>

          <div className="flex items-center gap-6">
            <FiUsers
              onClick={() => openAccessModal(folder)}
              className="text-primary cursor-pointer hover:text-primary/90"
              title="Manage Access"
            />

            <FiTrash2
              onClick={() => handleDeleteItem("folder", folder)}
              className="text-red-500 cursor-pointer hover:text-red-600"
              title="Delete Folder"
            />
          </div>
        </div>
      ))}

      {/* FILES */}
      {files.map((file) => (
        <div
          key={file.id}
          className="flex items-center justify-between px-4 py-2 hover:bg-gray-50 rounded group"
        >
          <FileItem file={file} />

          <div className="flex gap-6 items-center">
            <FiDownload
              className="text-secondary cursor-pointer hover:text-gray-700"
              title="Download File"
              onClick={() => onDownloadFile(file.file)}
            />

            <FiTrash2
              onClick={() => handleDeleteItem("file", file)}
              className="text-red-500 cursor-pointer hover:text-red-600"
              title="Delete File"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default FolderView;
